// 🕊️ Módulo Misión › Atenciones — pantallas ruteadas.
// Scaffold: pantallas reales (ya no abren un área vacía) con estado "En construcción"
// que describe la funcionalidad prevista. Se completarán cuando se defina el modelo de
// datos de atenciones (esquema/tablas/RPCs). Rutas mapeadas en App.tsx (/mision/*).
import type { ElementType } from 'react';
import { LayoutDashboard, CalendarPlus, MessageSquare, FileBarChart, Hammer } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card';

function Placeholder({ Icon, titulo, descripcion, previsto }: { Icon: ElementType; titulo: string; descripcion: string; previsto: string[] }) {
  return (
    <div className="p-6 space-y-6 max-w-3xl">
      <div className="flex items-center gap-3">
        <Icon className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-2xl font-bold">{titulo}</h1>
          <p className="text-sm text-muted-foreground">{descripcion}</p>
        </div>
      </div>
      <Card className="border-amber-500/40 bg-amber-50/40 dark:bg-amber-900/10">
        <CardContent className="p-6 space-y-3">
          <div className="flex items-center gap-2 text-amber-600">
            <Hammer className="w-5 h-5" /><span className="font-medium">En construcción</span>
          </div>
          <p className="text-sm text-muted-foreground">Esta pantalla estará disponible próximamente. Funcionalidad prevista:</p>
          <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
            {previsto.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}

export function MisionDashboard() {
  return <Placeholder Icon={LayoutDashboard} titulo="Dashboard de Atenciones"
    descripcion="Panel de indicadores de las atenciones de la misión."
    previsto={['Totales de atenciones por período, estado y responsable', 'Atenciones pendientes / agendadas / atendidas', 'Gráficos y accesos rápidos a las tareas del día']} />;
}

export function MisionAgendar() {
  return <Placeholder Icon={CalendarPlus} titulo="Agendar Atención"
    descripcion="Registrar y programar una nueva atención."
    previsto={['Selección de persona/beneficiario y tipo de atención', 'Fecha, hora y responsable asignado', 'Confirmación y notificación al responsable']} />;
}

export function MisionMensaje() {
  return <Placeholder Icon={MessageSquare} titulo="Enviar Mensaje"
    descripcion="Comunicación con los involucrados en una atención."
    previsto={['Redacción y envío de mensajes (recordatorios, seguimiento)', 'Selección de destinatarios por atención o grupo', 'Historial de mensajes enviados']} />;
}

export function MisionReporte() {
  return <Placeholder Icon={FileBarChart} titulo="Reporte de Atenciones"
    descripcion="Consulta y exportación de las atenciones."
    previsto={['Filtros por fecha, estado, tipo y responsable', 'Listado detallado con totales', 'Exportación a PDF y Excel']} />;
}

